import { createSelector } from 'reselect';

const selectDbaRegistries = (state: any) => state.dbaRegistries;


export const selectDbaRegistriesCurrentItem = createSelector([selectDbaRegistries], (dbaRegistries) => dbaRegistries.current);

export const selectDbaRegistriesListItems = createSelector([selectDbaRegistries], (dbaRegistries) => dbaRegistries.list);

export const selectDbaRegistriesItemById = (itemId: any) =>
    createSelector(selectDbaRegistriesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectDbaRegistriesQueryItems = createSelector([selectDbaRegistries], (dbaRegistries) => dbaRegistries.query);

export const selectDbaRegistriesCreatedItem = createSelector([selectDbaRegistries], (dbaRegistries) => dbaRegistries.create);

export const selectDbaRegistriesUpdatedItem = createSelector([selectDbaRegistries], (dbaRegistries) => dbaRegistries.update);

export const selectDbaRegistriesReadItem = createSelector([selectDbaRegistries], (dbaRegistries) => dbaRegistries.read);

export const selectDbaRegistriesDeletedItem = createSelector([selectDbaRegistries], (dbaRegistries) => dbaRegistries.delete);

export const selectDbaRegistriesSearchedItems = createSelector([selectDbaRegistries], (dbaRegistries) => dbaRegistries.search);

export const selectDbaRegistriesItemsCount = createSelector([selectDbaRegistries], (dbaRegistries) => dbaRegistries.count);

export const selectDbaRegistriesItemsFilter = createSelector([selectDbaRegistries], (dbaRegistries) => dbaRegistries.filter);